import React, { PureComponent } from 'react';
import { string, number, oneOfType, bool } from 'prop-types';
import Radium from 'radium';
import { connect } from 'react-redux';
import { UTButton, UTLabel, AlertHandler } from '@widergy/energy-ui';

import { UNSUBSCRIBED, PENDING, PROCEDURE } from 'constants/userForms';
import { DIGITAL_BILL, AUTOMATIC_DEBIT } from 'constants/common';
import { appConfig } from 'config/customization';
import UTTag from 'app/components/UTTag';
import UTUserForm from 'app/components/UTUserForm';
import { message } from 'utils/stringUtils';
import { accountPropTypes } from 'redux/accountHandlers';
import { formPropType } from 'redux/userFormHandlers';

import stylesJS from './styles';
import styles from './styles.module.scss';
import AdherenceWithTermsOfService from './components/AdherenceWithTermsOfService';

class ServiceAdherenceDetail extends PureComponent {
  state = { modalIsOpen: false };

  handleAdhereService = async () => {
    if (
      (this.props.service === AUTOMATIC_DEBIT && this.props.account.automatic_debit_enabled === false) ||
      (this.props.service === DIGITAL_BILL && this.props.account.digital_bill_enabled === false)
    )
      AlertHandler.error(message('AccountStatus:restricted'));
    else {
      this.setState({ modalIsOpen: true });
    }
  };

  handleModalClose = () => this.setState({ modalIsOpen: false });

  render() {
    const adheredMessage = this.props.withTitle ? (
      <div className={styles.flex}>
        <UTLabel xsmall semibold white>{`${this.props.title} - `}</UTLabel>
        <UTLabel xsmall semibold style={stylesJS.adheredMessage}>
          {message('AccountStatus:adheredService')}
        </UTLabel>
      </div>
    ) : (
      <UTLabel xxsmall white>
        {message('AccountStatus:adheredService')}
      </UTLabel>
    );

    const adhereMessage = this.props.withTitle ? (
      <div className={styles.flex}>
        <UTLabel xsmall bold>{`${this.props.title} - `}</UTLabel>
        <UTLabel xsmall bold style={stylesJS.adhereMessage}>
          {message('AccountStatus:adhere')}
        </UTLabel>
      </div>
    ) : (
      <UTLabel small white>
        {message('AccountStatus:adhere')}
      </UTLabel>
    );
    return (
      <div style={stylesJS.container}>
        <div style={stylesJS.detail}>
          {this.props.adherence === PENDING ? (
            <UTTag lightGray inProgress>
              {message('AccountStatus:adherenceInProgress')}
            </UTTag>
          ) : this.props.adherence !== UNSUBSCRIBED ? (
            <UTTag style={this.props.withTitle && stylesJS.reverse} checked>
              {adheredMessage}
            </UTTag>
          ) : (
            <div style={stylesJS.buttonContainer}>
              <UTButton
                onPress={this.handleAdhereService}
                className={`${styles.button} ${this.props.withTitle && styles.digitalBillButton}`}
              >
                {adhereMessage}
              </UTButton>
            </div>
          )}
          {this.state.modalIsOpen &&
            (!appConfig.digitalBillWithForm && this.props.service === DIGITAL_BILL ? (
              <AdherenceWithTermsOfService
                account={this.props.account.client_number}
                modalIsOpen={this.state.modalIsOpen}
                handleModalClose={this.handleModalClose}
              />
            ) : (
              <UTUserForm
                form={
                  this.props.service === AUTOMATIC_DEBIT
                    ? this.props.automaticDebitForm
                    : this.props.digitalBillForm
                }
                formType={PROCEDURE}
                accountId={this.props.account.id}
                showTitle
                useModal
                modalIsOpen={this.state.modalIsOpen}
                handleModalClose={this.handleModalClose}
              />
            ))}
        </div>
      </div>
    );
  }
}

ServiceAdherenceDetail.propTypes = {
  adherence: string.isRequired,
  account: oneOfType([number, accountPropTypes]),
  service: string.isRequired,
  title: string.isRequired,
  withTitle: bool,
  automaticDebitForm: formPropType,
  digitalBillForm: formPropType
};

const mapStateToProps = store => ({
  automaticDebitForm: store.utility.automaticDebitForm,
  digitalBillForm: store.utility.digitalBillForm
});

export default connect(mapStateToProps)(Radium(ServiceAdherenceDetail));
